import { buildAuthWindow, sanitizeDoubleSlashOnUrl } from '@/store/modules/kcLogin/helpers';
import { keycloakAdapter } from '@trimoz/trimoz-api-wrapper';
import { get, includes } from 'lodash';

let authWindow = null;
let searchInterval = null;

const state = {};

const actions = {
    async signInWindow({ commit, dispatch, rootGetters }, url) {
        let searchIntervalCounter = 0;
        const isRegister = includes(url, 'registrations');
        authWindow = buildAuthWindow(url);

        if (searchInterval) {
            clearInterval(searchInterval);
        }

        // This following setInterval approach can be avoided if we can have the keycloak template to send a window.postMessage when the login process has finished (not sure if this has security concerns).
        searchInterval = setInterval(async() => {
            searchIntervalCounter++;

            if (keycloakAdapter.validateCookieTs(document.cookie)) {
                if (!isRegister) {
                    authWindow.close();
                }

                clearInterval(searchInterval);

                // To do : find a way to know if user has already started  take appt process so we dont refresh page after login
                const shouldTrySilentSso = true;
                const establishmentId = get(rootGetters['establishment/getEstablishment'], 'id', '');
                let initOptions = {
                    onLoad: 'check-sso',
                    redirectUri: process.env.VUE_APP_KEYCLOAK_LOGIN_REDIRECT_URI + `${establishmentId}/take-appt`,
                };

                // If user has not yet filled any data we do an ordinary 'check-sso' that will refresh the page.
                // If the user has already selected a service category; we do a silentCheckSso login to persist the data by not making a page refresh.
                // NOTE: silentCheckSso has two main issues : it calls keycloak server 3 times AND uses cookies. We will need to find a better solution for this.
                if (shouldTrySilentSso) {
                    initOptions = {
                        ...initOptions,
                        checkLoginIframe: true,
                    };
                }

                const isAuth = await keycloakAdapter.init(initOptions);
                if (isAuth) {
                    dispatch('kcAuth/onLoginSuccess', true, { root: true });
                }
                else {
                    keycloakAdapter.deleteAuthTsCookie();
                }
            }

            if (searchIntervalCounter === 180) {
                if (!isRegister) {
                    authWindow.close();
                }
                clearInterval(searchInterval);
            }
        }, 1000);
    },
    async openSignInWindow({ dispatch, rootGetters }) {
        const locale = rootGetters['locale'];
        const isRegister = false;
        const establishmentId = get(rootGetters['establishment/getEstablishment'], 'id', '');
        await dispatch('signInWindow', keycloakAdapter.createKeycloakServerUrl({
            redirectUri: sanitizeDoubleSlashOnUrl(process.env.VUE_APP_KEYCLOAK_LOGIN_REDIRECT_URI) + `${establishmentId}/take-appt`, locale, isRegister,
        }));
    },

    async openRegisterWindow({ dispatch, rootGetters }) {
        const locale = rootGetters['locale'];
        const isRegister = true;
        await dispatch('signInWindow', keycloakAdapter.createKeycloakServerUrl({
            redirectUri: sanitizeDoubleSlashOnUrl(process.env.VUE_APP_KEYCLOAK_REGISTER_REDIRECT_URI), urlSuffix: locale, isRegister,
        }));
    },

    async logout({ rootGetters }) {
        const establishmentId = get(rootGetters['establishment/getEstablishment'], 'id', '');
        return keycloakAdapter.logout(establishmentId);
    },
};

export default {
    namespaced: true,
    actions,
    getters: {},
    mutations: {},
    state,
};
